import * as React from "react";
import { makeStyles } from "@material-ui/core";
import { DateRange } from "@material-ui/icons";
import { headerColor } from "@styles/color.styles";
import { fontFamily } from "@styles/type.styles";

export interface SectionHeaderProps {
  title: string;
  period?: string;
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    fontFamily,
    fontSize: 24,
    fontWeight: "bold",
    lineHeight: "29px",
    color: headerColor,
  },
  period: {
    display: "flex",
    alignItems: "center",
    textAlign: "right",
    color: headerColor,
    "& > .MuiSvgIcon-root": {
      height: 20,
      width: 18,
    },
    "& > div:last-child": {
      marginLeft: 17,
      fontFamily,
      fontSize: 21,
      lineHeight: "25px",
    },
  },
});

export const SectionHeader = ({ title, period }: SectionHeaderProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.title}>{title}</div>
      {period && (
        <div className={classes.period}>
          <DateRange />
          <div>{period}</div>
        </div>
      )}
    </div>
  );
};
